import { type FC } from 'react';

import { Text } from '../Typography';
import {
  amountStyles,
  lineCopyStyles,
  lineStyles,
} from './PricingDetails.styles';
import { type PricingLineProps } from './PricingDetails.types';

/**
 * A single pricing row: label, optional sublabel, and a preformatted amount.
 *
 * Exported on its own so MembershipSummaryCard (and other summaries) can reuse
 * the same row instead of duplicating the layout.
 */
const PricingLine: FC<PricingLineProps> = ({
  label,
  sublabel,
  amount,
  muted = false,
  emphasized = false,
  tone = 'default',
  className,
}) => {
  const color =
    tone === 'success'
      ? 'var(--text-success)'
      : muted
      ? 'var(--text-secondary)'
      : 'var(--text-primary)';
  const fontWeight = emphasized || tone === 'success' ? 'bold' : 'normal';

  return (
    <div css={lineStyles} className={className}>
      <div css={lineCopyStyles}>
        <Text as="span" size="sm" fontWeight={fontWeight} color={color}>
          {label}
        </Text>
        {sublabel ? (
          <Text as="span" size="xs" color="var(--text-secondary)">
            {sublabel}
          </Text>
        ) : null}
      </div>
      <Text
        as="span"
        size="sm"
        fontWeight={fontWeight}
        color={color}
        css={amountStyles}
      >
        {amount}
      </Text>
    </div>
  );
};

PricingLine.displayName = 'PricingLine';

export default PricingLine;
